// lib/classInfo.js
// 기록 RPE의 표시 계산. 계약: docs/architecture/app-v2/R5-R8.md A3.2, docs/architecture/record-daily-design.md 4.7
//   - RPE(회원이 고른 체감 강도 1~3)는 기록 화면(RecordsView)에 "여유/적당/힘듦"으로 보인다(A3.2 "코치님께 전달했어요"의 실체).
//   - R5의 수업 정보(부위·포커스) 계산은 R9에서 뺐다(사장님 결정 12·13: 수업에는 타입만 남고, 포커스는 운동 프로그램 탭,
//     부위는 서버가 타입에서 정한다). 타입·포커스 표는 lib/classTypes.js, 운동 프로그램은 lib/dailyPrograms.js.
// 이 파일은 import가 없다(scripts/test-class-info.mjs가 node로 그대로 불러 시험한다).

// RPE 1~3(A2.1 선택지 1 = 여유로웠어요, 2 = 적당했어요, 3 = 많이 힘들었어요)
const RPE_LABELS = { 1: "여유", 2: "적당", 3: "힘듦" };

// RPE 숫자 → "여유" | "적당" | "힘듦". 그 밖은 ""
export function rpeLabel(rpe) {
  return RPE_LABELS[rpe] || "";
}

// 기록(운동 상세·기록 요약 항목)의 RPE 표시. 응답에 rpe 키가 없으면(구버전 서버·요약 행) null을 돌려 아무것도 그리지 않는다.
// rpe가 null이면 "미입력". { text: "RPE 적당", level: 2 | 0 }
export function rpeDisplay(record) {
  if (!record || !Object.prototype.hasOwnProperty.call(record, "rpe")) {
    return null;
  }
  const label = rpeLabel(record.rpe);
  if (!label) return { text: "RPE 미입력", level: 0 };
  return { text: `RPE ${label}`, level: record.rpe };
}
